import { render, staticRenderFns } from "./CategoryTags.vue?vue&type=template&id=3407eeb6&scoped=true"
import script from "./CategoryTags.vue?vue&type=script&lang=ts"
export * from "./CategoryTags.vue?vue&type=script&lang=ts"
import style0 from "./CategoryTags.vue?vue&type=style&index=0&id=3407eeb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3407eeb6",
  null
  
)

export default component.exports